import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="footer-grid">

        <div>
          <h4 id="contact">Contact</h4>
          <p>support@codeion.in</p>
          <p>+91 8431750744</p>
          <p>Mon–Sat, 10AM–7PM</p>
        </div>

        <div>
          <h4>Join Us</h4>
          <p><Link to="/become-mentor">Become a Mentor</Link></p>
          <p><Link to="/careers">Careers</Link></p>
        </div>

        <div>
          <h4>Support</h4>
          <p><Link to="/faq">FAQs</Link></p>
          <p><Link to="/help-center">Help Center</Link></p>
        </div>

        <div>
          <h4>Legal</h4>
          <p><Link to="/about">About Us</Link></p>
          <p><Link to="/privacy">Privacy Policy</Link></p>
          <p><Link to="/terms">Terms & Conditions</Link></p>
          <p><Link to="/refund-policy">Refund Policy</Link></p>
        </div>

      </div>

      <div className="footer-bottom">
        © 2026 Codeion | All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;